<mat-card class="cardmetrica p-5">
    <mat-card-header>
        <mat-card-title>Top asistencias</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div class="counters">
            <div class="row">
                <div class="col-md-12 col-lg-4 col-4 text-center mb-4">
                    <div [class]="'rainbow' + this.productosService.VerificarCantidadDiaria()">{{this.productosService.CantidadDiaria}}
                    </div>
                    <div>
                        <p>Asistencias hoy</p>
                    </div>
                </div>
                <div class="col-md-12 col-lg-4 col-4 text-center mb-4">
                    <div [class]="'rainbow' + this.productosService.VerificarCantidadSemana()">{{this.productosService.CantidadSemanal}}</div>
                    <div>
                        <p>Asistencias semana</p>
                    </div>
                </div>
                <div class="col-md-12 col-lg-4 col-4 text-center mb-4">
                    <div [class]="'rainbow' + this.productosService.VerificarCantidadMes()">{{this.productosService.CantidadMensual}}</div>
                    <div>
                        <p>Asistencias mes</p>
                    </div>
                </div>
            </div>
        </div>
    </mat-card-content>
</mat-card>